module.exports = __WEBPACK_EXTERNAL_MODULE_82__;


//////////////////
// WEBPACK FOOTER
// external "ReactRouter"
// module id = 82
// module chunks = 0 1